<template>
  <div class="doalog_mini">
    <div class="dialog_con">
      <div
        class="dialog_detail"
        :style="{ width: dialogWidth, height: dialogHeight }"
        v-click-outside="clickClose"
      >
        <p class="dialog_title">{{ dialogTitle }}</p>
        <!-- <slot name="dialogDetail"></slot> -->
        <div v-if="dialogImg" class="dialog_img">
          <img :src="dialogImg" alt="" />
        </div>
        <div class="dialogDetail">
          <p>{{ successText }}</p>
        </div>
        <div class="button_col">
          <button
            class="cancel_btn"
            @click="oneMoreTry"
            v-if="this.$route.params.step * 1 === this.levelTotal"
          >
            再来一次
          </button>
          <button class="confirm_btn" @click="clickConfirm">
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogTitle: {
      type: String,
      default: "提示",
    },
    dialogImg: {
      type: String,
      default: "",
    },
    dialogWidth: {
      type: String,
      default: "400px",
    },
    dialogHeight: {
      type: String,
      default: "340px",
    },
    isConfirmDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      successText: "任务成功完成",
      buttonText: "下一关",
    };
  },
  computed: {
    level() {
      return this.$store.getters.level;
    },
    currentIndex() {
      return this.$store.getters.currentIndex;
    },
    nextIndex() {
      return this.$store.getters.nextIndex;
    },
    levelTotal() {
      return this.$store.getters.levelTotal;
    },
  },
  mounted() {
    if (this.$route.params.step * 1 === this.levelTotal) {
      this.successText = "恭喜完成所有关卡";
      this.buttonText = "确认";
    }
  },
  methods: {
    clickClose() {
      this.$emit("clickClose");
    },
    oneMoreTry() {
      let firstPratice = `${location.origin}/tools/keyboard/level/1${location.search}`;
      window.open(firstPratice, "_self");
    },
    clickConfirm() {
      this.$store.commit("currentIndex", this.$route.params.step * 1);
      //最后一关
      if (this.$route.params.step * 1 === this.levelTotal) {
        this.$emit("clickConfirm");
        return;
      }
      let next = this.$route.params.step * 1 + 1;
      this.$store.commit("nextIndex", next);
      this.$router.push({
        path: `/level/${next}`,
        query: this.$route.query,
      });
      this.$emit("clickConfirm");
    },
    clickCancel() {
      this.$emit("clickCancel");
    },
  },
};
</script>

<style lang="less" scoped>
.doalog_mini {
  position: fixed;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  height: 100%;
  .dialog_con {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    .dialog_detail {
      background-color: #fff;
      border-radius: 2em;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .dialog_title {
        background-color: #efefef;
        color: #3d3d3d;
        font-size: 18px;
        box-sizing: border-box;
        padding: 6px 0;
        text-align: center;
        border-radius: 2em 2em 0 0;
      }
      .dialogDetail {
        box-sizing: border-box;
        padding: 0 8px;
        p {
          text-align: center;
          font-size: 24px;
        }
      }
      .button_col {
        margin: 0 auto 16px;
        button[class$="_btn"] {
          cursor: pointer;
          width: 80px;
          height: 34px;
          border-radius: 17px;
          text-align: center;
          outline: none;
          border: none;
          color: #fff;
        }
        .cancel_btn {
          background-color: #ffbb00;
          margin-right: 1.5em;
        }
        .confirm_btn {
          background-color: #65b687;
        }
      }
    }
    .dialog_img {
      margin: 0 auto;
      width: 80%;
      height: 60%;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
</style>
